import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { transparent, light, info, secondary } = colors;
const { size } = typography;

const outlined = {
  base: {
    minHeight: pxToRem(39),
    color: light.main,
    borderColor: light.main,
    padding: `${pxToRem(9)} ${pxToRem(24)}`,

    "&:hover": {
      opacity: 0.75,
      backgroundColor: transparent.main,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(31),
    padding: `${pxToRem(6)} ${pxToRem(18)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(46),
    padding: `${pxToRem(12)} ${pxToRem(64)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  primary: {
    backgroundColor: transparent.main,
    borderColor: colors.primary.main,
    color: colors.primary.main,

    "&:hover": {
      backgroundColor: transparent.main,
      color: colors.primary.focus,
      borderColor: colors.primary.focus,
    },
  },

  secondary: {
    backgroundColor: transparent.main,
    borderColor: secondary.main,
    color: secondary.main,

    "&:hover": {
      backgroundColor: transparent.main,
      color: secondary.main,
    },
  },

  success: {
    backgroundColor: transparent.main,
    borderColor: colors.success.main,
    color: colors.success.main,

    "&:hover": {
      backgroundColor: transparent.main,
      color: colors.success.main,
    },
  },

  warning: {
    backgroundColor: transparent.main,
    borderColor: colors.warning.main,
    color: colors.warning.main,

    "&:hover": {
      backgroundColor: transparent.main,
      color: colors.warning.main,
    },
  },

  error: {
    backgroundColor: transparent.main,
    borderColor: colors.error.main,
    color: colors.error.main,

    "&:hover": {
      backgroundColor: transparent.main,
      color: colors.error.main,
    },
  },

  dark: {
    backgroundColor: transparent.main,
    borderColor: colors.divider,
    color: colors.text.main,

    "&:hover": {
      backgroundColor: transparent.main,
      color: colors.text.focus,
      borderColor: colors.light.main,
    },
  },

  info: {
    backgroundColor: transparent.main,
    borderColor: info.main,
    color: info.main,

    "&:hover": {
      backgroundColor: transparent.main,
      borderColor: info.focus,
      color: info.focus,
    },
  },
};

export default outlined;
